// src/components/ui/button.jsx

import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@lib/utils';

const buttonVariants = {
  primary:
    'sl-button-primary bg-primary-600 text-white hover:bg-primary-500 focus:ring-primary-500',
  secondary:
    'sl-button-secondary bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 focus:ring-primary-500',
  danger:
    'sl-button-danger bg-red-600 text-white hover:bg-red-500 focus:ring-red-500',
  ghost: 'sl-button-ghost hover:bg-gray-100 text-gray-700',
};

const buttonSizes = {
  sm: 'sl-button-sm px-3 py-1.5 text-sm',
  md: 'sl-button-md px-4 py-2 text-sm',
  lg: 'sl-button-lg px-5 py-2.5 text-base',
};

const Button = React.forwardRef(
  (
    {
      className,
      variant = 'primary',
      size = 'md',
      icon,
      isLoading = false,
      loadingText,
      disabled,
      fullWidth = false,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={cn(
          'sl-button',
          'inline-flex items-center justify-center gap-2',
          'font-medium rounded-md shadow-sm',
          'focus:outline-none focus:ring-2 focus:ring-offset-2',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'transition-colors duration-200',
          buttonVariants[variant],
          buttonSizes[size],
          fullWidth && 'w-full',
          className,
        )}
        disabled={isLoading || disabled}
        {...props}>
        {isLoading ? (
          <>
            <Loader2 className="sl-button-loader h-4 w-4 animate-spin" />
            {loadingText || children}
          </>
        ) : (
          <>
            {icon}
            {children}
          </>
        )}
      </button>
    );
  },
);

Button.displayName = 'Button';

export { Button, buttonVariants, buttonSizes };
